<template>
  <div class="index" v-loading="isLoadingShow">
    <div class="tableBox">
      <el-table :data="orderList" style="table" :style="{ 'font-family': 'PingFangSC-Regular, PingFang SC' }" :row-class-name="tableRowClassName" :header-cell-style="{
          background: 'rgba(59,196,146,0.1)',
          height: '56px',
        }">
        <el-table-column fixed prop="orderNo" label="订单编号" width="240"></el-table-column>
        <el-table-column prop="createdBy" label="创建人"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间">
          <template slot-scope="scope">{{
            $moment(scope.row.dateCreated).format('YYYY-MM-DD')
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createdTime" label="过期时间">
        <template slot-scope="scope">{{
          $moment(scope.row.expireTime).format('YYYY-MM-DD')
        }}</template>
      </el-table-column> -->

        <el-table-column prop="content" label="套餐类型"></el-table-column>
        <el-table-column prop="payAmount" label="套餐金额">
          <template slot-scope="scope">
            ￥{{
              scope.row.balancePay
                ? scope.row.balancePayment
                : scope.row.payAmount
            }}</template>
        </el-table-column>
        <el-table-column prop="buyNum" label="订单条数"></el-table-column>
        <el-table-column prop="state" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color: #3a84ff">待支付</div>
            <div v-if="scope.row.state == 1" style="color: #ff986f">审核中</div>
            <div v-if="scope.row.state == 2" style="
                color: #ff6161;
                display: flex;
                align-items: center;
                color: red;
              ">
              审核不通过
              <el-tooltip :content="scope.row.failReason" placement="bottom" effect="light">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
            <div v-if="scope.row.state == 3" style="color: #ccc">已关闭</div>
            <div v-if="scope.row.state == 4" style="color: #3bc492">已支付</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                  <el-button type="text" size="small">编辑</el-button>-->
            <div v-if="scope.row.state == 0" class="flex">
              <div class="paybtn" @click="handleToPay(scope.row)" style="margin-right: 8px">
                支付
              </div>
              <div class="nobtn" @click="handleToCancel(scope.row)">取消</div>
              <!-- <el-button size="small" class="paybtn" round>支付</el-button> -->
              <!-- <el-button size="small" class="nobtn" round @click="handleToCancel(scope.row)">取消</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination style="text-align: center; margin-top: 25px" v-if="totalCount" small :current-page="tableRequest.pageNum" :page-size="tableRequest.pageSize" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import { customerOrder, rechargeOrder } from '@/api/setUp.js'
export default {
  name: 'index',
  components: {},
  data () {
    return {
      tableRequest: {
        pageNumber: 0,
        size: 10,
      },
      totalCount: 0,
      totalCount1: 0,
      activeName: 'frist',
      paramsData: {
        pageNumber: 0,
        size: 10,
      },
      userInfo: {},
      orderList: [],
      packageList: [],
      isLoadingShow: false,
    }
  },
  methods: {
    tableRowClassName ({ row }) {
      if (row.state == 3) {
        return 'disablerow'
      }
    },
    handleCurrentChange (val) {
      this.tableRequest.pageNumber = val - 1
      this.getOrderList()
    },
    handleCurrentChange1 (val) {
      this.paramsData.pageNumber = val - 1
      this.getPackageList()
    },
    async getOrderList () {
      this.isLoadingShow = true
      const res = await customerOrder({
        pageNumber: this.tableRequest.pageNumber,
        size: this.tableRequest.size,
      })
      if (res.status == 200) {
        this.orderList = res.data
        this.orderList.map((item) => {
          item.payAmount = item.payAmount.toFixed(2)
          item.balancePayment = item.balancePayment.toFixed(2)
        })
        this.totalCount = +res.headers['x-total-count']
        this.isLoadingShow = false
      }
    },
    async getPackageList () {
      let res = await rechargeOrder(this.paramsData)
      this.packageList = res.data
      this.totalCount1 = +res.headers['x-total-count']
    },
    async changOrderState (url, data = {}, msg = '') {
      let res = await this.$http.post(url, data)
      this.getPackageList()
      this.getOrderList()
      this.$notify({
        title: '成功',
        message: msg,
        type: 'success',
      })
    },
    handleToPay (val) {
      // if(val.orderId.includes('tc')){
      //   //套餐
      //   this.$http.get(`order/${val.orderId}`).then(res=>{
      //     if(res.data.state==0){

      //     }else{

      //     }
      //   })
      // }else{
      //   //充值
      // }
      console.log(this.activeName, 'c123')
      switch (this.activeName) {
        case 'sec':
          this.$http
            .get(`/salary-service/customer/recharge_order/${val.id}`)
            .then((res) => {
              if (res.data.id) {
                this.$router.push({
                  name: 'chosePayment',
                  query: {
                    total: (+val.rechargeAmount).toFixed(2),
                    orderNum: val.orderNo,
                    type: 'recharge',
                  },
                })
              } else {
                this.getOrderList()
                this.getPackageList()
                this.$notify({
                  title: '失败',
                  message: '订单已过期',
                  type: 'warning',
                })
              }
            })
          break
        default:
          this.$http
            .get(`/salary-service/customer/order/${val.id}`)
            .then((res) => {
              if (res.data.id) {
                this.$router.push({
                  path: '/enterpriseIndex/chosePayment',
                  query: {
                    total: (+val.payAmount).toFixed(2),
                    orderNum: val.orderNo,
                  },
                })
              } else {
                this.getOrderList()
                this.getPackageList()
                this.$notify({
                  title: '失败',
                  message: '订单已过期',
                  type: 'warning',
                })
              }
            })
          break
      }
    },
    handleToCancel (val) {
      switch (this.activeName) {
        case 'sec':
          this.changOrderState(
            '/salary-service/customer/recharge_order/cancel',
            {
              id: val.id,
              state: 3,
            },
            '充值订单取消成功'
          )
          break
        default:
          this.$http
            .get(`/salary-service/customer/${val.id}/cancel`)
            .then((res) => {
              this.getPackageList()
              this.getOrderList()
              this.$notify({
                title: '成功',
                message: '套餐订单取消成功',
                type: 'success',
              })
            })
          break
      }
    },
  },
  mounted () {
    this.getOrderList()
    // this.getPackageList()
  },
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
}
.index {
  // margin: 18px 18px 0 18px;
  border-radius: 8px;
  background: #fff;
  padding: 24px 20px 0 20px;
  height: calc(100vh - 98px);
}
.paybtn {
  width: 56px;
  height: 28px;
  border-radius: 14px;
  border: 1px solid #3bc492;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #3bc492;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  padding: 0;
}
.nobtn {
  width: 56px !important;
  height: 28px !important;
  border-radius: 14px;
  border: 1px solid #838f99;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #838f99;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
/deep/.disablerow {
  color: #ccc !important;
}
.tableBox {
  height: calc(100vh - 190px);
  overflow: auto;
}
</style>
